import type { FunctionComponent } from "react";
import { useEffect } from "react";
import { graphql, useQueryLoader } from "react-relay";

import { ClientSideSuspense } from "~/components/common/client-side-suspense";
import { Edition, useEditionValue } from "~/lib/edition";
import type { searchExploreTopicsQuery } from "~/queries/__generated__/searchExploreTopicsQuery.graphql";

import { SearchExploreTopicsList } from "./search-explore-topics-list";
import { Container, StyledLoading, Title } from "./styles";

export const query = graphql`
  query searchExploreTopicsQuery($queueName: String!, $first: Int = 5) {
    queue(filter: { name: $queueName }) {
      ...searchExploreTopicsListQueue
    }
  }
`;

export type Props = {
  className?: string;
};

const queues: Record<Edition, string> = {
  [Edition.Asia]: "related_topic_homepage_asia_",
  [Edition.HongKong]: "related_topic_homepage_hk_",
  [Edition.International]: "related_topic_homepage_int_",
};

export const SearchExploreTopics: FunctionComponent<Props> = ({ className }) => {
  const [queryReference, loadQuery, disposeQuery] = useQueryLoader<searchExploreTopicsQuery>(query);
  const edition = useEditionValue({ initializeWithValue: true });

  useEffect(() => {
    loadQuery({ first: 5, queueName: queues[edition] });
    return () => {
      disposeQuery();
    };
  }, [loadQuery, disposeQuery, edition]);

  return (
    <Container className={className}>
      <Title>Explore topics</Title>
      <ClientSideSuspense fallback={<StyledLoading color="gray" />}>
        {queryReference && <SearchExploreTopicsList queryReference={queryReference} />}
      </ClientSideSuspense>
    </Container>
  );
};

SearchExploreTopics.displayName = "SearchExploreTopics";
